export default "__VITE_ASSET__w7gDMk7F__"